/**
 * Natural Nutrients — Cart Drawer Upsell
 * cart-upsell.js
 *
 * To customise: edit the CONFIG block only.
 */

(function () {
  'use strict';

  var CONFIG = {
    freeDeliveryThreshold: 10000,
    creatineBundleTarget:  3,
    creatineBundleMessage: 'Add {n} more and save 10% on your creatine',

    handles: {
      creatine:         'creapure-creatine-monohydrate-powder',
      wheyIsolate:      'grass-fed-whey-protein-isolate',
      wheyConcentrate:  'natural-grass-fed-whey-protein-concentrate-unflavoured',
      veganProtein:     'vegan-protein',
      supremeGreens:    'supreme-greens-powder-drink',
      digestiveEnzymes: 'natural-digestive-enzyme-complex-capsules',
      probiotics:       'probiotic-complex-10bn-cfu-high-strength',
      zma:              'zma-supplement-zinc-and-magnesium',
      magnesium:        'super-magnesium-citrate-bisglycinate-capsules',
      omega3:           'high-strength-optomega-3-fish-oil-capsules',
      brainPower:       'brain-power-natural-nootropic',
      zinc:             'zinc-citrate-supplement-15mg',
      vitaminD:         'vegan-vitamin-d3-capsules',
      wheySampleBox:    'whey-protein-sample-box',
    },

    variantOverrides: {},

    proteinGroup: [
      'grass-fed-whey-protein-isolate',
      'natural-grass-fed-whey-protein-concentrate-unflavoured',
      'vegan-protein',
    ],

    gutGroup: [
      'supreme-greens-powder-drink',
      'digestive-enzyme-complex',
      'probiotic-complex',
    ],

    heading: 'You might also want',

    red:    '#AB5153',
    dark:   '#1B2121',
    body:   '#68605A',
    off:    '#F2F2F2',
    border: '#E5E5E5',
    white:  '#FFFFFF',
  };

  var isOurUpdate = false;

  function injectStyles() {
    if (document.getElementById('nn-upsell-css')) return;
    var css = [
      '.nn-items { list-style:none; margin:0; padding:0; }',
      '.nn-item { display:flex; gap:14px; padding:16px 20px; border-bottom:1px solid ' + CONFIG.border + '; }',
      '.nn-item__img-wrap { width:70px; height:70px; flex-shrink:0; border-radius:8px; overflow:hidden; background:' + CONFIG.off + '; }',
      '.nn-item__img { width:100%; height:100%; object-fit:contain; display:block; }',
      '.nn-item__body { flex:1; min-width:0; }',
      '.nn-item__title { font-size:13px; font-weight:600; color:' + CONFIG.dark + '; margin:0 0 2px; line-height:1.3; }',
      '.nn-item__variant { font-size:12px; color:' + CONFIG.body + '; margin:0 0 6px; }',
      '.nn-item__discount-label { font-size:11px; font-weight:600; color:#3d7a45; margin:0 0 6px; }',
      '.nn-item__row { display:flex; justify-content:space-between; align-items:center; }',
      '.nn-item__qty { display:flex; align-items:center; border:1px solid ' + CONFIG.border + '; border-radius:99px; overflow:hidden; }',
      '.nn-item__qty-btn { background:none; border:none; width:30px; height:28px; cursor:pointer; font-size:16px; color:' + CONFIG.dark + '; font-family:inherit; display:flex; align-items:center; justify-content:center; transition:background 0.15s; }',
      '.nn-item__qty-btn:hover { background:' + CONFIG.off + '; }',
      '.nn-item__qty-btn:disabled { opacity:0.35; cursor:not-allowed; }',
      '.nn-item__qty-num { font-size:13px; font-weight:600; color:' + CONFIG.dark + '; min-width:24px; text-align:center; }',
      '.nn-item__price-wrap { text-align:right; }',
      '.nn-item__price { font-size:13px; font-weight:600; color:' + CONFIG.dark + '; }',
      '.nn-item__price--was { font-size:12px; font-weight:400; color:' + CONFIG.body + '; text-decoration:line-through; margin-right:2px; }',
      '.nn-item__price--now { font-size:13px; font-weight:600; color:' + CONFIG.dark + '; }',
      '.nn-item__price--saving { display:block; font-size:11px; font-weight:600; color:#3d7a45; margin-top:2px; }',
      '.nn-item__remove { background:none; border:none; cursor:pointer; font-size:11px; color:' + CONFIG.body + '; padding:0; font-family:inherit; margin-top:6px; text-decoration:underline; opacity:0.7; }',
      '.nn-item__remove:hover { opacity:1; }',
      '[data-subtotal] { display:block; }',
      '.nn-sub__was { font-size:12px; font-weight:400; color:' + CONFIG.body + '; text-decoration:line-through; margin-right:4px; }',
      '.nn-sub__saving { display:block; font-size:12px; font-weight:600; color:#3d7a45; margin-top:2px; }',
      '.nn-cart-empty { padding:40px 20px; text-align:center; color:' + CONFIG.body + '; font-size:14px; }',
      '#nn-cart-upsell { font-family:inherit; border-top:1px solid ' + CONFIG.border + '; }',
      '.nn-up__progress { padding:18px 20px 14px; }',
      '.nn-up__progress-label { font-size:13px; color:' + CONFIG.body + '; margin:0 0 10px; line-height:1.4; display:block; }',
      '.nn-up__progress-label strong { color:' + CONFIG.dark + '; font-weight:600; }',
      '.nn-up__progress-label.nn-up__unlocked { color:#3d7a45; font-weight:600; }',
      '.nn-up__track { height:5px; background:' + CONFIG.border + '; border-radius:99px; overflow:hidden; }',
      '.nn-up__bar { height:100%; background:' + CONFIG.red + '; border-radius:99px; transition:width 0.5s ease; }',
      '.nn-up__bar.nn-up__bar--full { background:#3d7a45; }',
      '.nn-up__section { padding:12px 20px 18px; }',
      '.nn-up__heading { font-size:11px; font-weight:700; letter-spacing:0.12em; text-transform:uppercase; color:' + CONFIG.body + '; margin:0 0 10px; }',
      '.nn-up__cards { display:flex; flex-direction:column; gap:10px; }',
      '.nn-up__card { display:flex; align-items:center; gap:14px; background:' + CONFIG.off + '; border-radius:14px; border:1.5px solid transparent; padding:12px 14px 12px 10px; }',
      '.nn-up__card--bundle { background:' + CONFIG.white + '; border-color:' + CONFIG.red + '; }',
      '.nn-up__img-wrap { width:64px; height:64px; flex-shrink:0; border-radius:8px; background:' + CONFIG.white + '; overflow:hidden; display:flex; align-items:center; justify-content:center; }',
      '.nn-up__img { width:100%; height:100%; object-fit:contain; }',
      '.nn-up__card-body { flex:1; min-width:0; }',
      '.nn-up__card-name { font-size:13px; font-weight:600; color:' + CONFIG.dark + '; margin:0 0 2px; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; line-height:1.3; }',
      '.nn-up__card-price { font-size:12px; color:' + CONFIG.body + '; margin:0 0 8px; }',
      '.nn-up__bundle-note { font-size:11px; font-weight:600; color:' + CONFIG.red + '; margin:0 0 8px; line-height:1.3; }',
      '.nn-up__btn { display:inline-block; background:' + CONFIG.dark + '; color:' + CONFIG.white + '; border:none; border-radius:99px; padding:8px 16px; font-size:12px; font-weight:600; cursor:pointer; font-family:inherit; line-height:1; transition:background 0.2s; white-space:nowrap; }',
      '.nn-up__btn:hover { background:#495959; }',
      '.nn-up__btn--bundle { background:' + CONFIG.red + '; }',
      '.nn-up__btn--bundle:hover { background:#8a3f41; }',
      '.nn-up__btn:disabled { opacity:0.55; cursor:not-allowed; }',
      '.nn-up__actions { display:flex; align-items:center; gap:10px; }',
      '.nn-up__view { font-size:11px; font-weight:600; color:' + CONFIG.body + '; text-decoration:underline; white-space:nowrap; flex-shrink:0; }',
      '.nn-up__view:hover { color:' + CONFIG.dark + '; }',
      '.nn-up__selectors { display:flex; flex-wrap:wrap; gap:6px; margin-bottom:8px; }',
      '.nn-up__select { -webkit-appearance:none; appearance:none; background:' + CONFIG.white + '; border:1px solid ' + CONFIG.border + '; border-radius:99px; padding:5px 24px 5px 10px; font-size:11px; font-family:inherit; color:' + CONFIG.dark + '; cursor:pointer; background-image:url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'10\' height=\'6\'%3E%3Cpath d=\'M1 1l4 4 4-4\' stroke=\'%2368605A\' stroke-width=\'1.5\' fill=\'none\' stroke-linecap=\'round\'/%3E%3C/svg%3E"); background-repeat:no-repeat; background-position:right 8px center; }',
      '.nn-up__select:focus { outline:none; border-color:' + CONFIG.dark + '; }',
      '@media (max-height:700px) {',
      '  .nn-up__progress { padding:12px 20px 10px; }',
      '  .nn-up__section { padding:8px 20px 12px; }',
      '  .nn-up__cards { gap:7px; }',
      '  .nn-up__card { padding:9px 12px 9px 8px; gap:10px; }',
      '  .nn-up__img-wrap { width:48px; height:48px; }',
      '  .nn-up__card-name { font-size:12px; }',
      '  .nn-up__card-price,.nn-up__bundle-note { font-size:11px; margin-bottom:6px; }',
      '  .nn-up__btn { padding:6px 12px; font-size:11px; }',
      '  .nn-item { padding:12px 16px; gap:10px; }',
      '  .nn-item__img-wrap { width:54px; height:54px; }',
      '}',
    ].join('\n');

    var el = document.createElement('style');
    el.id  = 'nn-upsell-css';
    el.textContent = css;
    document.head.appendChild(el);
  }

  function formatMoney(pence) {
    return '\u00a3' + (pence / 100).toFixed(2);
  }

  var productCache = {};

  function getCart() {
    return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); });
  }

  function getProduct(handle) {
    if (productCache[handle]) return Promise.resolve(productCache[handle]);
    return fetch('/products/' + handle + '.js', { cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { if (p) productCache[handle] = p; return p; })
      .catch(function () { return null; });
  }

  function getBestVariant(product) {
    var override = CONFIG.variantOverrides[product.handle];
    if (override) {
      var pinned = product.variants.filter(function (v) { return v.id === override; })[0];
      if (pinned) return pinned;
    }
    var pool = product.variants.filter(function (v) { return v.available; });
    if (!pool.length) pool = product.variants.slice();
    pool.sort(function (a, b) { return b.price - a.price; });
    return pool[0];
  }

  function findVariantByOptions(product, opts) {
    return product.variants.filter(function (v) {
      return opts.every(function (val, i) { return v['option' + (i + 1)] === val; });
    })[0] || null;
  }

  function getOptionGroups(product) {
    if (!product.options) return [];
    var groups = [];
    product.options.forEach(function (name, i) {
      var seen = {}, values = [];
      product.variants.forEach(function (v) {
        var val = v['option' + (i + 1)];
        if (!seen[val]) {
          seen[val] = true;
          var avail = product.variants.some(function (v2) {
            return v2['option' + (i + 1)] === val && v2.available;
          });
          values.push({ value: val, available: avail });
        }
      });
      if (values.length > 1) groups.push({ name: name, index: i, values: values });
    });
    return groups;
  }

  function renderCartItems(cart) {
    var container = document.querySelector('[data-products]');
    if (!container) return;

    var items = cart.items || [];

    if (items.length === 0) {
      container.innerHTML = '<div class="nn-cart-empty">Your cart is empty.</div>';
      updateSubtotalDisplay(cart);
      return;
    }

    var html = '<ul class="nn-items">';
    items.forEach(function (item) {
      var imgHtml = item.image
        ? '<img src="' + item.image + '" alt="' + item.product_title + '" class="nn-item__img" loading="lazy">'
        : '';

      var variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<p class="nn-item__variant">' + item.variant_title + '</p>' : '';

      var lineDiscount = item.original_line_price - item.line_price;
      var priceHtml;
      if (lineDiscount > 0) {
        priceHtml = '<span class="nn-item__price--was">' + formatMoney(item.original_line_price) + '</span>'
          + '<span class="nn-item__price--now">' + formatMoney(item.line_price) + '</span>'
          + '<span class="nn-item__price--saving">Save ' + formatMoney(lineDiscount) + '</span>';
      } else {
        priceHtml = '<span class="nn-item__price">' + formatMoney(item.line_price) + '</span>';
      }

      var discountLabel = '';
      if (item.discount_allocations && item.discount_allocations.length) {
        var titles = item.discount_allocations
          .filter(function (d) { return d.discount_application && d.discount_application.title; })
          .map(function (d) { return d.discount_application.title; });
        if (titles.length) discountLabel = '<p class="nn-item__discount-label">' + titles[0] + '</p>';
      }

      html += '<li class="nn-item" data-key="' + item.key + '">'
        + '<div class="nn-item__img-wrap">' + imgHtml + '</div>'
        + '<div class="nn-item__body">'
        + '<p class="nn-item__title">' + item.product_title + '</p>'
        + variantHtml
        + discountLabel
        + '<div class="nn-item__row">'
        + '<div class="nn-item__qty">'
        + '<button class="nn-item__qty-btn" data-nn-qty data-key="' + item.key + '" data-delta="-1">&#8722;</button>'
        + '<span class="nn-item__qty-num">' + item.quantity + '</span>'
        + '<button class="nn-item__qty-btn" data-nn-qty data-key="' + item.key + '" data-delta="1">&#43;</button>'
        + '</div>'
        + '<div class="nn-item__price-wrap">' + priceHtml + '</div>'
        + '</div>'
        + '<button class="nn-item__remove" data-nn-remove data-key="' + item.key + '">Remove</button>'
        + '</div></li>';
    });
    html += '</ul>';

    container.innerHTML = html;
    updateSubtotalDisplay(cart);

    container.querySelectorAll('[data-nn-qty]').forEach(function (btn) {
      btn.addEventListener('click', handleQtyChange);
    });
    container.querySelectorAll('[data-nn-remove]').forEach(function (btn) {
      btn.addEventListener('click', handleRemove);
    });
  }

  function updateSubtotalDisplay(cart) {
    var subtotalEl = document.querySelector('[data-subtotal]');
    if (!subtotalEl) return;

    isOurUpdate = true;

    var totalDiscount = cart.total_discount || 0;
    if (totalDiscount > 0) {
      subtotalEl.innerHTML = '<s class="nn-sub__was">' + formatMoney(cart.original_total_price) + '</s> '
        + formatMoney(cart.total_price)
        + '<span class="nn-sub__saving">You save ' + formatMoney(totalDiscount) + '</span>';
    } else {
      subtotalEl.textContent = formatMoney(cart.total_price);
    }

    var discountsEl = document.querySelector('[data-discounts]');
    if (discountsEl) {
      if (cart.cart_level_discount_applications && cart.cart_level_discount_applications.length) {
        discountsEl.innerHTML = cart.cart_level_discount_applications.map(function (d) {
          return '<div class="cart__item-sub cart__item-row"><div>' + d.title + '</div><div>-' + formatMoney(d.total_allocated_amount) + '</div></div>';
        }).join('');
      } else {
        discountsEl.innerHTML = '';
      }
    }

    setTimeout(function () { isOurUpdate = false; }, 100);
  }

  function renderUpsell(cart) {
    var container = document.querySelector('[data-cart-upsell]');
    if (!container) return;

    var items     = cart.items || [];
    var cartTotal = cart.total_price;

    if (items.length === 0) { container.innerHTML = ''; return; }

    var progressHtml = buildProgressBar(cartTotal);
    var rules        = getRules(items);

    if (rules.length === 0) { container.innerHTML = progressHtml; return; }

    Promise.all(rules.map(function (rule) {
      return getProduct(rule.handle).then(function (p) { return { rule: rule, product: p }; });
    })).then(function (results) {
      var valid = results.filter(function (r) { return r.product !== null; });
      if (valid.length === 0) { container.innerHTML = progressHtml; return; }

      var cardsHtml = valid.map(function (r) { return buildCard(r.rule, r.product); }).join('');
      container.innerHTML = progressHtml
        + '<div class="nn-up__section">'
        + '<p class="nn-up__heading">' + CONFIG.heading + '</p>'
        + '<div class="nn-up__cards">' + cardsHtml + '</div>'
        + '</div>';

      container.querySelectorAll('[data-nn-add]').forEach(function (btn) {
        btn.addEventListener('click', handleAdd);
      });
      container.querySelectorAll('[data-nn-bundle]').forEach(function (btn) {
        btn.addEventListener('click', handleBundle);
      });
      container.querySelectorAll('[data-nn-option]').forEach(function (sel) {
        sel.addEventListener('change', handleOptionChange);
      });
    });
  }

  function getRules(cartItems) {
    var h      = CONFIG.handles;

    /* Build two lookups:
       inCartByHandle — exact handle match (fast path)
       cats           — category flags derived from product title keywords
                        so rules work even when handles differ from CONFIG */
    var inCartByHandle = {};
    cartItems.forEach(function (item) { inCartByHandle[item.handle] = item; });

    /* Title-keyword categorisation — case-insensitive */
    function titleHas(item, keyword) {
      return (item.product_title || item.title || '').toLowerCase().indexOf(keyword) !== -1;
    }

    var cats = {
      creatine:   null,
      protein:    false,
      zma:        false,
      magnesium:  false,
      omega3:     false,
      brainPower: false,
      zinc:       false,
      vitaminD:   false,
      sampleBox:  false,
      greens:     false,
      enzymes:    false,
      probiotics: false,
    };

    cartItems.forEach(function (item) {
      var t = (item.product_title || item.title || '').toLowerCase();
      if (t.indexOf('creatine') !== -1)                              cats.creatine   = item;
      if (t.indexOf('whey') !== -1 || t.indexOf('vegan protein') !== -1 ||
          (t.indexOf('protein') !== -1 && t.indexOf('sample') === -1 &&
           t.indexOf('bar') === -1))                                 cats.protein    = true;
      if (t.indexOf('zma') !== -1)                                   cats.zma        = true;
      if (t.indexOf('magnesium') !== -1 && t.indexOf('zma') === -1) cats.magnesium  = true;
      if (t.indexOf('omega') !== -1 || t.indexOf('fish oil') !== -1) cats.omega3     = true;
      if (t.indexOf('brain') !== -1 || t.indexOf('nootropic') !== -1) cats.brainPower = true;
      if (t.indexOf('zinc') !== -1 && t.indexOf('zma') === -1)      cats.zinc       = true;
      if (t.indexOf('vitamin d') !== -1 || t.indexOf('vit d') !== -1 ||
          (t.indexOf('vitamin') !== -1 && t.indexOf(' d') !== -1))  cats.vitaminD   = true;
      if (t.indexOf('sample box') !== -1 || t.indexOf('sample') !== -1) cats.sampleBox  = true;
      if (t.indexOf('green') !== -1)                                 cats.greens     = true;
      if (t.indexOf('digestive') !== -1 || t.indexOf('enzyme') !== -1) cats.enzymes   = true;
      if (t.indexOf('probiotic') !== -1)                             cats.probiotics = true;
    });

    function cross(handle) { return { type: 'cross', handle: handle }; }

    /* notInCart checks BOTH the handle AND whether the category is active */
    function notProtein()   { return !cats.protein; }
    function notCreatine()  { return !cats.creatine; }
    function notZma()       { return !cats.zma; }
    function notMagnesium() { return !cats.magnesium; }
    function notOmega3()    { return !cats.omega3; }
    function notBrainPower(){ return !cats.brainPower; }
    function notZinc()      { return !cats.zinc; }
    function notVitaminD()  { return !cats.vitaminD; }
    function notInCart(handle) { return !inCartByHandle[handle]; }

    var rules = [];

    /* GUT HEALTH */
    if (cats.greens || cats.enzymes || cats.probiotics) {
      if (!cats.greens)    rules.push(cross(h.supremeGreens));
      if (!cats.enzymes)   rules.push(cross(h.digestiveEnzymes));
      if (!cats.probiotics && rules.length < 2) rules.push(cross(h.probiotics));
      if (rules.length === 0) {
        /* All gut products in cart */
        if (notVitaminD()) rules.push(cross(h.vitaminD));
        if (notOmega3() && rules.length < 2) rules.push(cross(h.omega3));
      }
      return rules.slice(0, 2);
    }

    /* CREATINE BUNDLE NUDGE */
    if (cats.creatine && cats.creatine.quantity < CONFIG.creatineBundleTarget) {
      var shortfall = CONFIG.creatineBundleTarget - cats.creatine.quantity;
      rules.push({
        type: 'bundle', handle: h.creatine,
        lineKey: cats.creatine.key, currentQty: cats.creatine.quantity,
        targetQty: CONFIG.creatineBundleTarget, addQty: shortfall,
        message: CONFIG.creatineBundleMessage.replace('{n}', shortfall),
      });
      if (notProtein()) rules.push(cross(h.wheyIsolate));
      else if (notZma()) rules.push(cross(h.zma));
      return rules.slice(0, 2);
    }

    /* PROTEIN IN CART */
    if (cats.protein) {
      if (notCreatine()) rules.push(cross(h.creatine));
      if (notZma() && rules.length < 2) rules.push(cross(h.zma));
      return rules.slice(0, 2);
    }

    /* CREATINE AT TARGET, NO PROTEIN */
    if (cats.creatine && !cats.protein) {
      rules.push(cross(h.wheySampleBox));
      if (notInCart(h.wheyIsolate) && rules.length < 2) rules.push(cross(h.wheyIsolate));
      return rules.slice(0, 2);
    }

    /* ZMA */
    if (cats.zma) {
      if (notMagnesium()) rules.push(cross(h.magnesium));
      if (notCreatine() && rules.length < 2) rules.push(cross(h.creatine));
      return rules.slice(0, 2);
    }

    /* MAGNESIUM */
    if (cats.magnesium) {
      if (notZma())   rules.push(cross(h.zma));
      if (notOmega3() && rules.length < 2) rules.push(cross(h.omega3));
      return rules.slice(0, 2);
    }

    /* BRAIN POWER */
    if (cats.brainPower) {
      if (notOmega3())    rules.push(cross(h.omega3));
      if (notMagnesium() && rules.length < 2) rules.push(cross(h.magnesium));
      return rules.slice(0, 2);
    }

    /* OMEGA 3 */
    if (cats.omega3) {
      if (notBrainPower()) rules.push(cross(h.brainPower));
      if (notMagnesium() && rules.length < 2) rules.push(cross(h.magnesium));
      return rules.slice(0, 2);
    }

    /* VITAMIN D */
    if (cats.vitaminD) {
      if (notOmega3()) rules.push(cross(h.omega3));
      if (notZinc() && rules.length < 2) rules.push(cross(h.zinc));
      return rules.slice(0, 2);
    }

    /* ZINC */
    if (cats.zinc) {
      if (notVitaminD())  rules.push(cross(h.vitaminD));
      if (notMagnesium() && rules.length < 2) rules.push(cross(h.magnesium));
      return rules.slice(0, 2);
    }

    /* SAMPLE BOX */
    if (cats.sampleBox) {
      if (notInCart(h.wheyIsolate)) rules.push(cross(h.wheyIsolate));
      if (notCreatine() && rules.length < 2) rules.push(cross(h.creatine));
      return rules.slice(0, 2);
    }

    return rules;
  }

  function buildProgressBar(cartTotal) {
    var threshold = CONFIG.freeDeliveryThreshold;
    var pct       = Math.min(Math.round((cartTotal / threshold) * 100), 100);
    var unlocked  = cartTotal >= threshold;
    var message   = unlocked
      ? 'Free delivery unlocked'
      : 'Add <strong>' + formatMoney(threshold - cartTotal) + '</strong> more for free delivery';
    return '<div class="nn-up__progress">'
      + '<span class="nn-up__progress-label' + (unlocked ? ' nn-up__unlocked' : '') + '">' + message + '</span>'
      + '<div class="nn-up__track"><div class="nn-up__bar' + (unlocked ? ' nn-up__bar--full' : '') + '" style="width:' + pct + '%"></div></div>'
      + '</div>';
  }

  function buildCard(rule, product) {
    var defaultVariant = getBestVariant(product);
    var image          = product.featured_image || '';
    var name           = product.title;
    var handle         = product.handle;
    var imgHtml        = image
      ? '<div class="nn-up__img-wrap"><img src="' + image + '" alt="' + name + '" class="nn-up__img" loading="lazy" width="64" height="64"></div>'
      : '';

    if (rule.type === 'bundle') {
      return '<div class="nn-up__card nn-up__card--bundle">' + imgHtml
        + '<div class="nn-up__card-body">'
        + '<p class="nn-up__card-name">' + name + '</p>'
        + '<p class="nn-up__bundle-note">' + rule.message + '</p>'
        + '<button class="nn-up__btn nn-up__btn--bundle" data-nn-bundle'
        + ' data-line-key="' + rule.lineKey + '" data-target-qty="' + rule.targetQty + '" data-add-qty="' + rule.addQty + '">'
        + 'Add ' + rule.addQty + ' more</button>'
        + '</div></div>';
    }

    var groups = getOptionGroups(product);
    var selectorsHtml = '';
    if (groups.length) {
      selectorsHtml = '<div class="nn-up__selectors">';
      groups.forEach(function (group) {
        selectorsHtml += '<select class="nn-up__select" data-nn-option="' + group.index + '" aria-label="' + group.name + '">';
        group.values.forEach(function (v) {
          var isDefault = v.value === defaultVariant['option' + (group.index + 1)];
          selectorsHtml += '<option value="' + v.value + '"'
            + (isDefault ? ' selected' : '')
            + (!v.available ? ' disabled' : '')
            + '>' + v.value + '</option>';
        });
        selectorsHtml += '</select>';
      });
      selectorsHtml += '</div>';
    }

    return '<div class="nn-up__card" data-nn-card data-handle="' + handle + '">'
      + imgHtml
      + '<div class="nn-up__card-body">'
      + '<p class="nn-up__card-name">' + name + '</p>'
      + '<p class="nn-up__card-price" data-nn-price>' + formatMoney(defaultVariant.price) + '</p>'
      + selectorsHtml
      + '<div class="nn-up__actions">'
      + '<button class="nn-up__btn" data-nn-add data-variant-id="' + defaultVariant.id + '">Add to order</button>'
      + '<a class="nn-up__view" href="/products/' + handle + '">View</a>'
      + '</div>'
      + '</div></div>';
  }

  function handleAdd(e) {
    var btn     = e.currentTarget;
    var card    = btn.closest('[data-nn-card]');
    var handle  = card ? card.getAttribute('data-handle') : null;
    var product = handle ? productCache[handle] : null;

    var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);

    if (product && product.options && card) {
      var selects = card.querySelectorAll('[data-nn-option]');
      if (selects.length > 0) {
        var defaultVariant = getBestVariant(product);
        var opts = [];
        product.options.forEach(function (name, i) {
          opts[i] = defaultVariant['option' + (i + 1)];
        });
        selects.forEach(function (s) {
          opts[parseInt(s.getAttribute('data-nn-option'), 10)] = s.value;
        });
        var matched = findVariantByOptions(product, opts);
        if (matched) variantId = matched.id;
      }
    }

    if (!variantId || isNaN(variantId)) {
      btn.textContent = 'Select options';
      return;
    }

    var original = btn.textContent.trim();
    btn.disabled = true;
    btn.textContent = 'Adding...';

    fetch('/cart/add.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ id: variantId, quantity: 1 }),
    })
    .then(function (response) {
      if (!response.ok) {
        return response.json().then(function (data) {
          throw new Error(data.description || data.message || 'Could not add item');
        });
      }
      btn.textContent = 'Added';
      return fullRefresh();
    })
    .catch(function (err) {
      btn.disabled    = false;
      btn.textContent = (err && err.message) ? err.message : original;
      setTimeout(function () {
        btn.textContent = original;
        btn.disabled    = false;
      }, 2500);
    });
  }

  function handleBundle(e) {
    var btn       = e.currentTarget;
    var lineKey   = btn.getAttribute('data-line-key');
    var targetQty = parseInt(btn.getAttribute('data-target-qty'), 10);
    var addQty    = parseInt(btn.getAttribute('data-add-qty'), 10);
    var original  = btn.textContent.trim();
    btn.disabled  = true;
    btn.textContent = 'Updating...';

    fetch('/cart/change.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ id: lineKey, quantity: targetQty }),
    })
    .then(function () { return fullRefresh(); })
    .catch(function () {
      btn.disabled    = false;
      btn.textContent = 'Add ' + addQty + ' more';
    });
  }

  function handleQtyChange(e) {
    var btn     = e.currentTarget;
    var key     = btn.getAttribute('data-key');
    var delta   = parseInt(btn.getAttribute('data-delta'), 10);
    var item    = btn.closest('.nn-item');
    var qtyEl   = item && item.querySelector('.nn-item__qty-num');
    var current = qtyEl ? parseInt(qtyEl.textContent, 10) : 1;
    var newQty  = Math.max(0, current + delta);
    btn.disabled = true;

    fetch('/cart/change.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ id: key, quantity: newQty }),
    })
    .then(function () { return fullRefresh(); })
    .catch(function () { btn.disabled = false; });
  }

  function handleRemove(e) {
    var btn = e.currentTarget;
    var key = btn.getAttribute('data-key');
    btn.disabled = true;

    fetch('/cart/change.js', {
      method:  'POST',
      headers: { 'Content-Type': 'application/json' },
      body:    JSON.stringify({ id: key, quantity: 0 }),
    })
    .then(function () { return fullRefresh(); })
    .catch(function () { btn.disabled = false; });
  }

  function handleOptionChange(e) {
    var sel     = e.currentTarget;
    var card    = sel.closest('[data-nn-card]');
    if (!card) return;

    var handle  = card.getAttribute('data-handle');
    var product = productCache[handle];
    if (!product) return;

    var defaultVariant = getBestVariant(product);
    var opts = [];
    product.options.forEach(function (name, i) {
      opts[i] = defaultVariant['option' + (i + 1)];
    });
    card.querySelectorAll('[data-nn-option]').forEach(function (s) {
      opts[parseInt(s.getAttribute('data-nn-option'), 10)] = s.value;
    });

    var matched = findVariantByOptions(product, opts);
    var priceEl = card.querySelector('[data-nn-price]');
    var addBtn  = card.querySelector('[data-nn-add]');

    if (matched) {
      if (priceEl) priceEl.textContent = formatMoney(matched.price);
      if (addBtn) {
        addBtn.disabled    = !matched.available;
        addBtn.textContent = matched.available ? 'Add to order' : 'Out of stock';
      }
    } else {
      if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Unavailable'; }
    }
  }

  var isRefreshing  = false;
  var refreshQueued = false;

  function fullRefresh() {
    if (isRefreshing) {
      refreshQueued = true;
      return Promise.resolve();
    }
    isRefreshing = true;

    return getCart().then(function (cart) {
      renderCartItems(cart);
      ensureUpsellContainer();
      renderUpsell(cart);
    }).then(function () {
      isRefreshing = false;
      if (refreshQueued) {
        refreshQueued = false;
        fullRefresh();
      }
    }).catch(function () {
      isRefreshing = false;
    });
  }

  var scheduleTimer = null;
  function scheduleRefresh() {
    clearTimeout(scheduleTimer);
    scheduleTimer = setTimeout(fullRefresh, 400);
  }

  function ensureUpsellContainer() {
    if (!document.querySelector('[data-cart-upsell]')) {
      var target = document.querySelector('.cart__checkout--drawer')
                || document.querySelector('[name="checkout"]');
      if (target) {
        var div = document.createElement('div');
        div.id  = 'nn-cart-upsell';
        div.setAttribute('data-cart-upsell', '');
        div.setAttribute('aria-live', 'polite');
        target.parentNode.insertBefore(div, target);
      }
    }
  }

  function bindEvents() {
    /* Cart change events */
    ['cart:refresh', 'cart:updated', 'cart:item-added'].forEach(function (name) {
      document.addEventListener(name, scheduleRefresh);
    });

    /* Detect drawer opening via class change on #CartDrawer.
       Streamline toggles 'is-active', 'drawer--open', or removes 'hidden'
       when the drawer opens — any class/attr change on the drawer triggers us. */
    var drawer = document.getElementById('CartDrawer');
    if (drawer) {
      new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
          /* Class or attribute change = drawer state changed */
          if (mutations[i].type === 'attributes') {
            /* Only refresh if drawer appears to be open (not hidden) */
            var isOpen = !drawer.hasAttribute('hidden')
                      && drawer.style.display !== 'none'
                      && !drawer.classList.contains('is-hidden');
            if (isOpen) {
              scheduleRefresh();
            }
            break;
          }
        }
      }).observe(drawer, { attributes: true, attributeFilter: ['class', 'style', 'aria-hidden', 'hidden'] });

      /* Also watch footer for upsell container removal */
      var footer = drawer.querySelector('.cart__footer');
      if (footer) {
        new MutationObserver(function () {
          if (!document.querySelector('[data-cart-upsell]')) {
            ensureUpsellContainer();
            scheduleRefresh();
          }
        }).observe(footer, { childList: true });
      }
    }
  }

  injectStyles();

  document.addEventListener('DOMContentLoaded', function () {
    bindEvents();
    /* Initial render in case drawer is already populated */
    fullRefresh();
  });

  if (document.readyState !== 'loading') {
    bindEvents();
    fullRefresh();
  }

})();